import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';

function TokenSettle({apiUrl}) {
    const [tokenSettle, setTokenSettle] = useState({
        operation: properties.OPERATIONS.tokensettle,
        timestamp:"",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        method: properties.HTTP_METHOD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        authCode: properties.AUTHCODE,
        security:""
    });
    
    const [isDpaFlag, setIsDpaFlag] = useState("false");

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;
    
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setTokenSettle({ ...tokenSettle, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setTokenSettle({ ...tokenSettle, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setTokenSettle({ ...tokenSettle, password: e.target.value });
    }

    function changeDesc(e) {
        setTokenSettle({ ...tokenSettle, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setTokenSettle({ ...tokenSettle, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setTokenSettle({ ...tokenSettle, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setTokenSettle({ ...tokenSettle, token: e.target.value });
    }

    function changeAuthCode(e) {
        isNotNullCheck(e.target.value,"WPG_authCode");
        setTokenSettle({ ...tokenSettle, authCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setTokenSettle({ ...tokenSettle, region: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    function submitTokenSettleForm(e) {
        e.preventDefault();
        isNotNullCheck(tokenSettle.token,"WPG_token");
        isNotNullCheck(tokenSettle.password,"vendorPwd");
        isNotNullCheck(tokenSettle.vendorid,"WPG_vendorID");
        isNotNullCheck(tokenSettle.transactionid,"WPG_transID");
        isNotNullCheck(tokenSettle.authCode,"WPG_authCode");
        isNotNullCheck(tokenSettle.value,"WPG_value");
        isNotNullCheck(tokenSettle.region,"WPG_region");
        isNotNullCheck(tokenSettle.currency,"WPG_currency");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(tokenSettle.region === "NoR"){
                setTokenSettle({...tokenSettle, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#tokensettle_timestamp").val(time);
            var digest = md5(time + tokenSettle.vendorid +
                tokenSettle.transactionid + tokenSettle.method +
                tokenSettle.description +
                tokenSettle.value + tokenSettle.currency + tokenSettle.region +
                tokenSettle.token + tokenSettle.authCode + tokenSettle.password);
            $("#tokensettle_security").val(digest);
            $("#tokensettleForm").attr('action', apiUrl).submit();
        }
    }
    
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var tokenSettleTemplate = (
        <div className="operation-form">
            <h2>Token Settle</h2>
            <form className="form-horizontal" id="tokensettleForm" onSubmit={submitTokenSettleForm} method='post'>
                <input type="hidden" name="WPG_timestamp" id="tokensettle_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="tokensettle_security" value="" />
                <input type="hidden" name="WPG_operation" value={tokenSettle.operation} />
                <input type="hidden" name="WPG_method" value={tokenSettle.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={tokenSettle.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={tokenSettle.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={tokenSettle.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={tokenSettle.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={tokenSettle.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={tokenSettle.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={tokenSettle.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={tokenSettle.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Auth Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_authCode" value={tokenSettle.authCode} onChange={changeAuthCode} />
                        <div className="error-msg" name="WPG_authCode">Auth Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="tokensettleButton" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

    return tokenSettleTemplate;
    
}

export default TokenSettle;